import { CSSProperties } from 'react';

type IconCssProps = CSSProperties & { iconBg: string, iconFg: string };

export interface IconProps {
  className?: string;
  onClick?: () => void;
  style?: IconCssProps;
}

export const cleanProps = (props: IconProps) => {
  const className = props?.className ?? '';
  const style = props?.style ?? ({} as IconCssProps);
  const onClick = props?.onClick ?? undefined;
  return {
    className,
    onClick,
    style,
  };
};
